/**
 * AJ-03 — la page « En attente de la chargée » de l'accueil : qui attend au
 * comptoir de son centre, depuis quand, et pour quoi ; puis ce que la chargée
 * a répondu (décision 342). Rien de médical.
 */
import { z } from 'zod';
import { TYPES_BENEFICIAIRE } from '../rules/beneficiaire.js';
import { MOTIFS_ATTENTE_CHARGEE, REPONSES_CHARGEE } from '../rules/attente-chargee.js';
import { ACTIONS_VERIFICATION } from '../rules/verification-chargee.js';
import { schemaNoteChargee } from './note-chargee.js';
export const schemaPatientAttendantLaChargee = z.object({
    personneId: z.uuid(),
    nom: z.string(),
    prenom: z.string().nullable(),
    typeBeneficiaire: z.enum(TYPES_BENEFICIAIRE),
    /** L'entreprise du patient (celle de son titulaire pour un ayant droit), ou aucune. */
    entreprise: z.string().nullable(),
    /** Ce qu'il attend encore de la chargée ; vide une fois qu'elle a répondu (décision 342). */
    motifs: z.array(z.enum(MOTIFS_ATTENTE_CHARGEE)),
    /** L'heure d'arrivée du jour au centre (décision 175), sinon l'heure du signalement. */
    depuis: z.iso.datetime(),
    /** Décision 342 — l'accueil qui l'a envoyée (son arrivée du jour), ou `null` (écart seul). */
    envoyeePar: z.string().nullable(),
    reponse: z.enum(REPONSES_CHARGEE),
    /** « Ne peut pas entrer » : pourquoi, tel que la fiche l'affiche. */
    motifRefus: z.string().nullable(),
    /** Quand la chargée a répondu ; `null` tant qu'elle ne l'a pas fait. */
    reponduLe: z.iso.datetime().nullable(),
    /** Quand l'accueil a ouvert la ligne ; avant `reponduLe`, la réponse reste à voir. */
    vueLe: z.iso.datetime().nullable(),
    /** Décision 343 — la note jointe pour la chargée, écrite à ce centre. */
    noteChargee: schemaNoteChargee.nullable(),
    /**
     * Décision 343 — l'accueil qui lit la ligne peut ajouter ou modifier la note :
     * fiche encore à confirmer, note absente ou écrite à ce centre. Calculé par l'API.
     */
    noteModifiable: z.boolean(),
    /**
     * Décision 372 — une vérification demandée aujourd'hui : ce que dit la
     * plateforme (la raison) et ce que dit la personne. `null` sans demande.
     */
    verification: z
        .object({
        note: z.string(),
        raison: z.string(),
        /** Décision 399 — ce que la réponse fait : le libellé que l'accueil lit après « Peut entrer ». */
        action: z.enum(ACTIONS_VERIFICATION),
    })
        .nullable(),
});
export const schemaAttentesDeLaChargee = z.object({
    /** Le seuil réglé dans Configuration : au-delà, la ligne passe en évidence. */
    seuilMinutes: z.number().int().positive(),
    /** La plus récente en tête (décision 342). */
    patients: z.array(schemaPatientAttendantLaChargee),
});
//# sourceMappingURL=attente-chargee.js.map